import { getWrapper } from './axios'
const CHATBLOCK_URL = process.env.RAZZLE_CHATBLOCK_URL

export const getAdvUsers = () => {
    return getWrapper(CHATBLOCK_URL)
}
